
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import moment from 'moment';

export class GenRestorationCurve {

    customersImpacted: number;
    fipsCode: string;
    groupId: number;
    highThreshold: number;
    lowThreshold: number;
    morethanHighThreshold: boolean;
    morethanLowThreshold: boolean;
    outageId: string;
    runStartTime: moment.Moment;
    totalCustomers: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genRestorationCurve: GenRestorationCurve);

    constructor( input?: GenRestorationCurve ) {
        if ( input && typeof input !== 'number' ) {
            this.customersImpacted = input.customersImpacted; // float [number]
            this.fipsCode = input.fipsCode; // string [string]
            this.groupId = input.groupId; // int [number]
            this.highThreshold = input.highThreshold; // float [number]
            this.lowThreshold = input.lowThreshold; // float [number]
            this.morethanHighThreshold = input.morethanHighThreshold; // boolean [boolean]
            this.morethanLowThreshold = input.morethanLowThreshold; // boolean [boolean]
            this.outageId = input.outageId; // string [string]
            if ( input.runStartTime && typeof input.runStartTime === 'string' ) {
                this.runStartTime = moment(input.runStartTime).utc();
            } else {
                this.runStartTime = input.runStartTime;
            }
            this.totalCustomers = input.totalCustomers; // float [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenRestorationCurve[] {
        if (arr && arr.map) {
          return arr.map(a => new GenRestorationCurve(a));
        } else {
          return [];
        }
    }
}

